import { atom } from 'recoil';

export const isItineraryOpenState = atom({
  key: 'isItineraryOpenState',
  default: false
});
